<template>
    <div id="home">
        <div class="header_nav">
            <div class="header">
                <div class="logoWord">华医云动态心电血压后台管理系统</div>
            </div> 
        </div>
        <div class="homeBox">
            <div class="leftBox">
                <div class="person">
                    <img class="headImg" :src="headImg" alt="">
                    <p class="name">{{userInfo.staffName}}</p>
                </div>
                <ul class="navList">
                    <li v-if="operateSa||operate" :class="{'selected':nav=='/hospManage'}" @click="select('/hospManage')">医院管理</li>
                    <li v-if="operateSa" :class="{'selected':nav=='/staffManage'}" @click="select('/staffManage')">员工管理</li>
                    <li :class="{'selected':nav=='/caseList'}" @click="select('/caseList')">病例管理</li>
                    <li :class="{'selected':nav=='/statistics'}" @click="select('/statistics')">数据统计</li>
                    <li :class="{'selected':nav=='regionData'}" @click="select('regionData')">地区监控</li>
                    <li v-if="finance" :class="{'selected':nav=='/finance'}" @click="select('/finance')">财务管理</li>
                    <li :class="{'selected':nav=='/logUser'}" @click="select('/logUser')">日志管理</li>
                    <li v-if="!operateSa" @click="editPassword=true">修改密码</li>
                    <p class="exit" @click="exit()">退出登录</p>
                </ul>
            </div>
            <div class="contents">
                <router-view></router-view>
            </div>
        </div>
        <el-dialog title="修改密码" :visible.sync="editPassword" width="500px" center> 
            <el-form ref="editPwd" :model="editPwd">
                <div class="dialogBox">
                    <div class="list">
                        <span class="word">旧密码</span>
                        <el-input v-model="editPwd.old" type="password" style="width:90%;" placeholder='请输入旧密码'></el-input>
                    </div>
                    <div class="list">
                        <span class="word">新密码</span>
                        <el-input v-model="editPwd.new" type="password" style="width:90%;" placeholder='请输入新密码'></el-input>
                    </div>
                    <div class="list">
                        <span class="word">确认密码</span>
                        <el-input v-model="editPwd.newTwo" type="password" style="width:90%;" placeholder='请再次输入新密码'></el-input>
                    </div>
                    <div class="btnBox">
                        <el-button type="primary" @click="changePwd()">确定</el-button>
                    </div>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
import footerPage from '@/components/footer'
import headerImg from '@/assets/headImg.jpg'
import { Loading } from 'element-ui';
export default {
    name:'home',
    components:{
        footerPage
    },
    data(){
        return{
            nav:'/hospManage',
            identity:'',
            userInfo:{
                userRoleList:[]
            },
            editPwd:{
                old:'',
                new:'',
                newTwo:''
            },
            operateSa:false,//运营超管
            finance:false,//财务
            operate:false,//运营员工
            editPassword:false,//修改密码
            headImg:headerImg,
            loadingInstance:''
        }
    },
    mounted(){
        this.nav=this.$route.path
        this.userInfo=this.$common.getStorage('loginMsg');
        if(this.userInfo.userRoleList.indexOf('operate_sa')>-1){
            this.operateSa=true
        }
        if(this.userInfo.userRoleList.indexOf('finance')>-1){
            this.finance=true
        }
        if(this.userInfo.userRoleList.indexOf('operate')>-1){
            this.operate=true
        }
    },
    methods:{
        select(path){
            this.$router.push({path:path});
        },
        //退出
        exit(){
            this.$common.removeStorage();
            this.$router.push({path:'/login'});
        },
        //修改密码
        changePwd(){
            if(this.editPwd.old==this.editPwd.new){
                this.$message.error('新密码与旧密码一致!');
                return;
            }
            if(this.editPwd.new.length<6){
                this.$message.error('密码不得小于六位!');
                return;
            }
            if(this.editPwd.newTwo!=this.editPwd.new){
                this.$message.error('两次密码输入不一致!');
                return;
            }
            this.loadingInstance=Loading.service({
                text:'密码修改中...',
                spinner:'el-icon-loading',
                background:'rgba(0, 0, 0, 0.8)'
            });
            this.$ajax.post(this.$domain.modifyPassword,{
                phoneNumber:this.userInfo.staffTel,
                oldPassword:this.$common.pwd99(this.editPwd.old),
                newPassword:this.$common.pwd99(this.editPwd.new)
            })
            .then(ret=>{
                this.loadingInstance.close();
                if(ret.data.code==10){
                    this.$message.success('密码修改成功,请重新登陆!');
                    this.$router.push({path:'/login'});
                }
                else if(ret.data.code=='401'){
                    this.$message.error('登录失效,请重新登陆!');
                    this.$router.push({path:'/login'});
                }
                else if(ret.data.code!='11'){
                    this.$message.error(ret.data.message);
                }
            })
            .catch(()=>{
                this.loadingInstance.close();
            })
        }
    },
    watch:{
        $route(){
            let path = this.$route.path
            this.nav=path;
        },
    }
}
</script>
<style lang="scss" scoped>
#home{
    width:100%;
    min-width: 1400px;
    box-sizing: border-box;
    background-color: #F9F9F9;
    position: relative;
    top:0;
    bottom:0;
    height:100%;
}
#home .header_nav{
    width:100%;
    text-align: left;
    overflow: hidden;
    box-sizing: border-box;
    position: fixed;
}
#home .header_nav .header{
    width:100%;
    background-color: #5C6BC0;
    padding:0px 50px 0 20px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
}
#home .logoWord{
    font-size: 26px;
    line-height: 80px;
    background-image: url('../assets/logo2.png');
    background-size: auto 60px;
    background-position: 0px 10px;
    background-repeat: no-repeat;
    padding-left:68px;
    color:#fff;
    box-sizing: border-box
}
#home .curService{
    display: inline-block;
    background-image: url('../assets/tel.png');
    background-repeat: no-repeat;
    padding-left:50px;
    background-size: 30px 30px;
    background-position: 20px 26px;
    line-height: 80px;
    color:#fff;
}
#home .homeBox{
    width:100%;
    overflow: hidden;
    position: absolute;
    display: flex;
    justify-content: flex-start;
    top:80px;
    bottom:0;
}
#home .leftBox{
    width:200px;
    background-color: #333333;
    height:100%;
    /* position: absolute; */
    /* top:0;
    left:0;
    bottom:0; */
}
#home .person{
    width:100%;
    text-align: center;
    padding: 20px 0;
    box-sizing: border-box;
}
#home .person .headImg{
    width:120px;
    height:120px;
    border-radius: 50%;
}
#home .person .name{
    color:#fff;
    line-height: 50px;
    font-size: 16px;
}
#home .leftBox .exit{
    color:#fff;
    margin-top:50px;
    cursor: pointer;
}
#home .navList{
    width:100%;
    list-style: none;
    font-size: 16px;
    color:#fff;
}
#home .navList li{
    line-height: 50px;
    padding:0 20px;
    cursor: pointer;
    width: 100%;
    box-sizing: border-box;
}
#home .contents{
    /* padding-left:200px; */
    box-sizing: border-box;
    overflow: auto;
    /* position: absolute; */
    width:100%;
    /* top:0;
    left:200px;
    bottom:0px; */
    box-sizing: border-box;
}
#home .selected{
    background-color: #5c6bc0;
}
#home .dialogBox{
    margin:10px auto;
    padding:10px;
    .list{
        display: flex;
        justify-content: flex-start;
        margin-top:16px;
        .word{
            display: inline-block;
            font-size: 16px;
            width:120px;
            text-align: left;
            line-height: 30px;
        }
    }
    .btnBox{
        text-align: right;
        margin-top:30px;
    }
}
</style>





// WEBPACK FOOTER //
// src/page/home.vue